<template>
  <div class="scripts-page">
    <el-card shadow="never" style="margin-bottom: 16px">
      <template #header>
        <div class="header-bar">
          <span>💬 话术管理（自动留言/评论/私信模板）</span>
          <div>
            <el-button size="small" @click="exportConfig" :loading="exporting">⬇ 导出定制配置</el-button>
            <el-button size="small" @click="triggerImport" :loading="importing">⬆ 导入定制配置</el-button>
            <el-button size="small" type="primary" :loading="saving" @click="save">💾 保存</el-button>
            <input ref="fileInput" type="file" accept=".json" style="display:none" @change="onImportFile" />
          </div>
        </div>
      </template>
      <el-alert type="info" :closable="false" show-icon
        title="话术即改即生效，无需重启系统"
        description="留痕/评论话术用于同行视频下的自动评论；私信话术用于互关后的自动私信。占位符 {vx_id} 和 {address} 会自动替换为下方配置的微信号和门店地址。每条话术占一行，系统随机选用。" />
    </el-card>

    <el-card shadow="never" style="margin-bottom: 16px">
      <template #header><span>⚙️ 占位符配置</span></template>
      <el-form label-width="110px" style="max-width: 560px">
        <el-form-item label="微信号 {vx_id}">
          <el-input v-model="placeholders.vx_id" placeholder="如 vx_ccj7205，私信引流时自动替换" />
        </el-form-item>
        <el-form-item label="门店地址 {address}">
          <el-input v-model="placeholders.address" placeholder="如 深圳市福田区xx路xx号，私信引流时自动替换" />
        </el-form-item>
      </el-form>
    </el-card>

    <el-row :gutter="16">
      <el-col :span="12" v-for="g in groups" :key="g.key" style="margin-bottom: 16px">
        <el-card shadow="never">
          <template #header>
            <div class="group-header">
              <span>{{ g.label }}</span>
              <el-tag size="small" type="info">{{ count(g.key) }} 条</el-tag>
            </div>
          </template>
          <div class="group-desc">{{ g.desc }}</div>
          <el-input
            type="textarea"
            :rows="6"
            :model-value="joined(g.key)"
            :placeholder="'每条一行，如：' + (defaults[g.key] ? defaults[g.key][0] : '')"
            @input="(v) => setLines(g.key, v)"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'ScriptManager',
  data() {
    return {
      loading: false,
      saving: false,
      exporting: false,
      importing: false,
      groups: [],
      scripts: {},
      defaults: {},
      placeholders: { vx_id: '', address: '' }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const d = await api.get('/intent/scripts')
        this.groups = d.groups || []
        this.scripts = d.scripts || {}
        this.defaults = JSON.parse(JSON.stringify(this.scripts))
        this.placeholders = d.placeholders || { vx_id: '', address: '' }
      } catch (e) {
        this.$message.error('加载失败: ' + e.message)
      } finally {
        this.loading = false
      }
    },
    count(key) {
      return (this.scripts[key] || []).length
    },
    joined(key) {
      return (this.scripts[key] || []).join('\n')
    },
    setLines(key, text) {
      const lines = (text || '').split('\n').map(s => s.trim()).filter(Boolean)
      this.scripts[key] = lines
    },
    async save() {
      this.saving = true
      try {
        const r = await api.post('/intent/scripts', {
          scripts: this.scripts,
          vx_id: this.placeholders.vx_id,
          address: this.placeholders.address
        })
        if (r.success) {
          this.$message.success('话术已保存，自动执行时生效')
          this.loadData()
        } else {
          this.$message.warning(r.detail || '保存失败')
        }
      } catch (e) {
        this.$message.error('保存失败: ' + e.message)
      } finally {
        this.saving = false
      }
    },
    async exportConfig() {
      this.exporting = true
      try {
        const resp = await fetch('/api/v1/intent/export')
        const data = await resp.json()
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })
        const a = document.createElement('a')
        a.href = URL.createObjectURL(blob)
        a.download = '定制配置_' + new Date().toISOString().slice(0, 10) + '.json'
        a.click()
        URL.revokeObjectURL(a.href)
        this.$message.success('定制配置已导出')
      } catch (e) {
        this.$message.error('导出失败: ' + e.message)
      } finally {
        this.exporting = false
      }
    },
    triggerImport() {
      this.$refs.fileInput.click()
    },
    async onImportFile(e) {
      const file = e.target.files[0]
      if (!file) return
      this.importing = true
      try {
        const text = await file.text()
        const data = JSON.parse(text)
        if (!data.industry) throw new Error('不是有效的定制配置文件（缺少 industry）')
        const r = await api.post('/intent/import', {
          industry: data.industry,
          peers: data.peers || [],
          placeholders: data.placeholders || {},
          merge_peers: true
        })
        if (r.success) {
          this.$message.success('定制配置已导入，页面已刷新')
          this.loadData()
        } else {
          this.$message.warning(r.detail || '导入失败')
        }
      } catch (err) {
        this.$message.error('导入失败: ' + err.message)
      } finally {
        this.importing = false
        e.target.value = ''
      }
    }
  }
}
</script>

<style scoped>
.header-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.group-desc {
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
}
</style>
